export const APPLICATION_STATUS = {
  APPLICATION_CREATED: "APPLICATION_CREATED",
  APPLICATION_SUBMITTED: "APPLICATION_SUBMITTED",
  IDENTITY_VERIFICATION: "IDENTITY_VERIFICATION",
  IDENTITY_VERIFICATION_SUBMITTED: "IDENTITY_VERIFICATION_SUBMITTED",
  ACCEPT_FEES: "ACCEPT_FEES",
  ACCEPTED_FEES: "ACCEPTED_FEES",
  ACCEPT_TERMS_AND_CONDITIONS: "ACCEPT_TERMS_AND_CONDITIONS",
  ACCEPTED_TERMS_AND_CONDITIONS: "ACCEPTED_TERMS_AND_CONDITIONS",
  APPLICATION_APPROVED: "APPLICATION_APPROVED",
  APPLICATION_REJECTED: "APPLICATION_REJECTED",
  APPLICATION_NEEDS_INFO: "APPLICATION_NEEDS_INFO",
} as const;

export type ApplicationStatus = (typeof APPLICATION_STATUS)[keyof typeof APPLICATION_STATUS];
